import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { discountTemplatesKeys } from '../../api/query-keys/discount-templates';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useCreateHost = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['hosts']);

  return useMutation({
    mutationFn: ({
      email,
      firstName,
      lastName,
      phoneNumber,
    }: {
      email: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
    }) => hostsApi.createHost(email, firstName, lastName, phoneNumber),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: discountTemplatesKeys.all,
      });
      onSuccess?.();
      toast.success(t('hosts:dialogs.invite.success'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
